import { z } from "zod";
import { TApiObjectBase, TObjectBase } from "../base";

export const TRawContractorGroup = z
  .object({
    name: z.string(),
    properties: z.array(z.string()),
    contactEmail: z.string().optional(),
    contactPhone: z.string().optional(),
    receivesNotifications: z.boolean().optional(),
  })
  .extend(TObjectBase.shape);
export type IRawContractorGroup = z.infer<typeof TRawContractorGroup>;

export const TRawContractorGroupMember = z
  .object({
    admin: z.boolean().optional(),
    operationManagerProperties: z.array(z.string()).optional(),
  })
  .extend(TObjectBase.shape);
export type IRawContractorGroupMember = z.infer<typeof TRawContractorGroupMember>;

export const TRawContractorGroupTask = z
  .object({
    propertyID: z.string(),
  })
  .extend(TObjectBase.shape);
export type IRawContractorGroupTask = z.infer<typeof TRawContractorGroupTask>;

export const TRawContractorGroupFile = z
  .object({
    name: z.string(),
    type: z.string().optional(),
    size: z.number().optional(),
    path: z.string().optional(),
    tags: z
      .object({
        standard: z.array(z.string()).optional(),
      })
      .optional(),
  })
  .extend(TObjectBase.shape);
export type IRawContractorGroupFile = z.infer<typeof TRawContractorGroupFile>;

export const TApiContractorGroup = z
  .object({
    name: z.string(),
    properties: z.array(z.string()),
    contactPhone: z.string(),
    contactEmail: z.string(),
    receivesNotifications: z.boolean(),
  })
  .extend(TApiObjectBase.shape);
export type IApiContractorGroup = z.infer<typeof TApiContractorGroup>;

export const TApiContractorGroupsResponse = z.object({
  contractorGroups: z.array(TApiContractorGroup),
});
export type IApiContractorGroupsResponse = z.infer<typeof TApiContractorGroupsResponse>;

export const TApiCreateContractorGroupRequest = z.object({
  name: z.string(),
  properties: z.array(z.string()),
  contactPhone: z.string().nullish(),
  contactEmail: z.string().nullish(),
  receivesNotifications: z.boolean().nullish(),
});
export type IApiCreateContractorGroupRequest = z.infer<typeof TApiCreateContractorGroupRequest>;

export const TApiCreateContractorGroupResponse = z
  .object({
    id: z.string(),
  })
  .extend(TApiContractorGroup.shape);
export type IApiCreateContractorGroupResponse = z.infer<typeof TApiCreateContractorGroupResponse>;
